<template>
  <div class="bg-white rounded-[20px] relative shadow-md px-4">
    <div class="grid pt-4" style="grid-template-columns: auto minmax(0, 1fr);">
      <img
        class="w-[120px] h-[120px] rounded-[10px] object-cover object-top"
        :src="happening.speaker.photo_url"
        :alt="happening.speaker.name"
      />
      <div class="ml-4">
        <p class="text-[16px] font-semibold uppercase" :class="[highlightColor === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']">
          {{ getProperHallName(happening.hall) }}
        </p>
        <p class="text-[16px]" :class="[highlightColor === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']">
          {{ happening.start }}—{{ happening.end }}
        </p>
        <p class="text-brand-gray-900 truncate font-semibold text-[20px]">
          {{ happening.speaker.name }}
        </p>
        <p class="text-brand-gray-500 truncate font-medium text-[18px]">
          {{ happening.speaker.position }}
        </p>
      </div>
    </div>

    <div class="mt-4 pb-4">
      <p class="font-semibold text-big-body text-brand-gray-900">
        {{ happening.title }}
      </p>

      {{ truncatedDescription }}

      <button
        v-if="hasTextOverflow"
        @click.prevent="action"
        class="
          inline-block
          font-medium
          transition-all
          duration-200
          hover:opacity-80
          text-body
        "
        :class="[highlightColor === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']"
      >
        Více informací
      </button>
    </div>

    <div class="pb-4" v-if="votingOpened">
      <RadioButton
        v-if="shouldHaveRadio"
        @clicked="removeTimeSlot"
        :name="'timeslot-mobile-' + happening.timeslot.index"
        :radioValue="happening.hall"
        :radioId="happening.timeslot.index.toString() + '-' + happening.hall"
        label="To chci vidět"
        v-model="selected"
      />
    </div>
  </div>
</template>

<script>
import RadioButton from "../Atomic/Radio.vue";
import axios from 'axios';

export default {
  emits: ["update:timeslotSelections"],
  props: {
    happening: {
      type: Object,
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    shouldHaveRadio: {
      type: Boolean
    },

    highlightColor: {
      type: String,
      default: 'orange'
    },
    votingOpened: {
      type: Boolean,
      default: false
    }
  },

  components: {
    RadioButton,
  },

  data() {
    return {
      textTruncateChars: 80,
    };
  },

  methods: {
    action() {
      this.$emit("clicked", {...this.happening, time: this.talkTime()});
    },

    talkTime() {
      if (this.happening.start === undefined) {
        return "Čas přednášky";
      }

      return this.happening.start + "-" + this.happening.end;
    },

    getProperHallName(hallname) {
      if (hallname === "purple") {
        return "Notino sál";
      }

      return "Leadhub sál";
    },

    async removeTimeSlot() {
      if (this.selected === this.happening.hall) {
        const res = await axios.delete(
          `/api/timeslot/${this.happening.timeslot.index}`
        );
        this.$emit("update:timeslotSelections", res.data);
      }
    },
  },

  computed: {
    truncatedDescription() {
      let text = this.happening.annotation;

      if (text.length && text.length > this.textTruncateChars) {
        text = text.substring(0, this.textTruncateChars);
        text += "...";
      }

      return text;
    },

    hasTextOverflow() {
      return this.happening.annotation.length > this.textTruncateChars;
    },

    selected: {
      get() {
        if (
          this.timeslotSelections === undefined ||
          this.timeslotSelections.timeslots === undefined
        ) {
          return "";
        }

        if (
          this.timeslotSelections.timeslots[this.happening.timeslot.index] ===
          null
        ) {
          return "";
        }

        return this.timeslotSelections.timeslots[
          this.happening.timeslot.index
          ] === 0
          ? "heureka"
          : "purple";
      },

      async set() {
        const hallAsString = this.happening.hall === "heureka" ? 0 : 1;

        const res = await axios.post(
          `/api/timeslot/${this.happening.timeslot.index}/${hallAsString}`
        );

        this.$emit("update:timeslotSelections", res.data);
      },
    },
  },
};
</script>

<style>
</style>
